<template>
  <div class="content">
    
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="main">
      <div class="banane">
        <img src="../assets/images/loan/loantop.png" />
      </div>
      <div class="Plate1">
        <div class="Plate1-title wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="titlebig">三大专享福利</div>
          <div class="titlemin">THREE ENJOYED BENEFITS</div>
        </div>
        <div class="Plate1-img1 wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="Plate1-imgpa">
            <img src="../assets/images/loan/111562901025_.pic_hd.png" oncontextmenu="return false;"/>
          </div>
          <div class="Plate1-imgpa">
            <img src="../assets/images/loan/131562901027_.pic_hd.png" oncontextmenu="return false;"/>
          </div>
          <div class="Plate1-imgpa">
            <img src="../assets/images/loan/121562901026_.pic_hd.png" oncontextmenu="return false;"/>
          </div>
        </div>
      </div>
      <div class="con" style="background:#fff;">
        <div class="Plate1-title wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="titlebig">四大优势</div>
          <div class="titlemin">FOUR ADVANTAGES</div>
        </div>
        <div class="wow slideInUp">
          <img src="../assets/images/loan/loan3.png" oncontextmenu="return false;"/>
        </div>
      </div>
      <div class="Plate1">
        <div class="Plate1-title wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
          <div class="titlebig">分期装修 贷款计算器</div>
          <div class="titlemin">STAGE DECORATION LOAN CALCULATOR</div>
        </div>
        <div class="Plate1-img wow slideInUp">
          <div class="Plate1-left wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
            <div class="inpusts">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="贷款金额" prop="money">
                  <el-input v-model="ruleForm.money" placeholder="请输入贷款金额"></el-input>
                </el-form-item>
                <el-form-item label="贷款周期" prop="region">
                  <el-select v-model="ruleForm.region" placeholder="请选择贷款周期">
                    <el-option label="12期" :value="12"></el-option>
                    <el-option label="24期" :value="24"></el-option>
                    <el-option label="36期" :value="36"></el-option>
                    <el-option label="48期" :value="48"></el-option>
                    <el-option label="60期" :value="60"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-button @click="Calculation">计算还款金额</el-button>
            </div>
            <div class="mianright">
              <div class="mianright-text">
                <div class="lnnerlayer">
                  <span style="font-size: 20px;">每月应还金额</span>
                  <br />
                  <Span style="font-size: 12px;">
                    (
                    <span style="color:#fd7c67;">*</span>请输入左侧所需信息)
                  </Span>
                  <br />
                  <span style="color:#fd7c67;">▼</span>
                  <div class="Amountdue">{{repayment}}</div>
                  <div style="font-size: 12px;" v-if="repayment != ''">仅供参考,以合同为准</div>
                </div>
              </div>
              <div class="tablew">
                <div class="lnnerlayer">
                  <span style="font-size: 20px;">还款演示</span>
                  <br />
                  <Span style="font-size: 18px;">
                    (以
                    <span style="color:#fd7c67;">60</span>期为例)
                  </Span>
                  <br />
                  <span style="color:#fd7c67;">▼</span>
                </div>

                <div style="width:100%;">
                  <el-table :data="tableData" style="width: 100%;">
                    <el-table-column prop="date" label="贷款金额"></el-table-column>
                    <el-table-column prop="name" label="每月还款"></el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div class="Plate1-right wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
            <div class="application">
              <div class="application-title">快速申请分期贷</div>
              <div class="application-form">
                <Tpicker2 @citydata="getcitydata" :cidatas="posdata"></Tpicker2>
                <el-input v-model="username" placeholder="请输入您的姓名"></el-input>
                <el-input v-model="phone" placeholder="请输入您的号码"></el-input>
                <el-button @click="LoanReservations">立即预约</el-button>
              </div>
              <div class="button-text">
                已有
                <span style="color:#fd7c67;">{{nubs}}</span>人预约申请装修分期服务
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-img wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <div class="Mask">
          <div class="mask-title">只需5步，装修无忧</div>
          <ul>
            <li>
              <div class="itemcent">
                <i class="iconfont icon-shenqing"></i>
                <div>申请贷款</div>
              </div>
            </li>
            <li>
              <div class="itemcent">
                <i class="iconfont icon-hetong"></i>
                <div>签订合同</div>
              </div>
            </li>
            <li>
              <div class="itemcent">
                <i class="iconfont icon-feiyongshenqing"></i>
                <div>申请支用</div>
              </div>
            </li>
            <li>
              <div class="itemcent">
                <i class="iconfont icon-paizhao"></i>
                <div>上门拍照</div>
              </div>
            </li>
            <li>
              <div class="itemcent">
                <i class="iconfont icon-weibiaoti5"></i>
                <div>贷款投放</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="askanswer-wp wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
      <div class="askanswer">
        <div>
          <div class="answer-title">答疑解惑</div>
          <div>
            <div class="askanswer-left">
              <div class="ask">申请需要准备什么材料？</div>
              <div class="answer">
                1、产权为夫妻双方所有，提供：夫妻身份证+结婚证+社保卡+房产证+近半年流水；
                <br />
                <br />2、产权为个人所有，提供：身份证+社保卡+房产证+近半年流水。
              </div>
            </div>
            <div class="askanswer-right">
              <div class="ask">自建房可以申请贷款吗？</div>
              <div class="answer">1、商品房、农村自建房、单位产权房、拆迁安置房、经济适用房均可申请贷款。</div>
              <div class="ask">房贷不是建行，是否可以申请？</div>
              <div class="answer">1、建行及他行房贷客户均可申请办理。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import BottomFoot from "../components/BottomFoot.vue";
import Freequote from "../components/Freequote.vue";
import Rightnav from "../components/Rightnav.vue";
import Tpicker2 from "../components/Tpicker2.vue";
import WOW from "wowjs";
export default {
  components: {
  
    BottomFoot,
    Freequote,
    Rightnav,
    Tpicker2
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "家装设计师、室内设计师、装修设计师、大咖云集、整装桔家云整装，汇聚百位大咖装修设计师，为您提供各种风格，各种面积，各种户型的设计方案，一对一专业服务。"
        }
      ]
    };
  },
  data() {
    return {
      nub: "8",
      nubs: "",
      number: "",
      showquote: false,
      posdata: "",
      username: "",
      phone: "",
      source: "",
      //每月还款金额
      repayment: "",
      ruleForm: {
        money: null,
        region: 60
      },
      rules: {
        money: [
          { required: true, message: "请输入贷款金额", trigger: "blur" },
          { min: 5, max: 7, message: "长度在 5 到 7 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择贷款周期", trigger: "change" }
        ]
      },
      tableData: [
        {
          date: "10万",
          name: "1987元"
        },
        {
          date: "30万",
          name: "5960元"
        },
        {
          date: "50万",
          name: "9934元"
        }
      ]
    };
  },
  methods: {
    getshow(data) {
      // console.log("data", data);
      this.showquote = data;
    },
    getpositions(data) {
      // console.log('datass',data);
      this.posdata = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },

    getcitydata(data) {
      // console.log('getcitydata',data);
      this.posdata.province = data[0];
      this.posdata.city = data[1];
      this.posdata.area = data[2];
      this.getdata();
    },
    Calculation() {
      let mrate = (0.0499 * 1) / 12;
      let num = parseFloat(this.ruleForm.region);
      let totalmoney = parseFloat(this.ruleForm.money);
      this.repayment = Math.round(totalmoney / num) + totalmoney * 0.0032;
    },
    LoanReservations: async function() {
      if (this.username == "") {
        this.$message({
          message: "姓名不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.phone == "") {
        this.$message({
          message: "电话号码不能为空",
          type: "warning"
        });
        return false;
      }
      // if (/^([\u4e00-\u9fa5]){2,7}$/.test(this.username) == false) {
      //   this.$message({
      //     message: "姓名格式不正确",
      //     type: "warning"
      //   });
      //   return false;
      // }
      if (/^1[3-9]\d{9}$/.test(this.phone) == false) {
        this.$message({
          message: "电话号码格式不正确",
          type: "warning"
        });
        return false;
      }
      let data = {
        clientcity: this.posdata.city,
        clientname: this.username,
        clientprovince: this.posdata.province,
        county: this.posdata.area,
        moblephone: this.phone,
        source: "1",
        registertype: "2"
      };
      let res = await this.exequy.appointment(data);

      //console.log("res", res);
      // this.number=res.data.num;
      // console.log("www",this.number)
      if (res.data.code == 0) {
        this.nubs = res.data.num;
        this.$message({
          message: "预约成功",
          type: "success"
        });
      }
    },
    getnub: async function() {
      let data = {
        registertype: "2"
      };
      let res = await this.exequy.applicants(data);
      this.nubs = res.data.num;
    }
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
  },
  created: async function() {
    let self = this;
    self.getnub();
  }
};
</script>
<style scoped>
img {
  width: 100%;
}
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
  overflow: hidden;
}
.banane {
  width: 100%;
  margin: 0 auto;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
.Plate1 {
  width: 100%;
  height: 500px;
}
.Plate1-title {
  width: 100%;
  text-align: center;
  padding-top: 25px;
}
.titlebig {
  font-size: 40px;
  letter-spacing: 0px;
  color: #262626;
}
.titlemin {
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #222222;
}
.Plate1-img,
.Plate1-img1 {
  width: 98%;
  margin: 0 auto;
  margin-top: 40px;
}
.Plate1-img1 {
  display: flex;
  justify-content: space-around;
}
.Plate1-imgpa {
  width: 234px;
  height: 257px;
  float: left;
}
.Plate1-imgpa img:hover {
  width: 250px;
  height: 270px;
}
.Plate1-imgpa img {
  width: 100%;
  height: 100%;
}
.Plate1-left {
  width: 78%;
  float: left;
  height: 300px;
  box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.14);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
}
.inpusts {
  width: 40%;
  float: left;
}
.mianright {
  width: 60%;
  float: left;
}
.el-select {
  width: 100%;
}
.el-button--default {
  background-image: linear-gradient(180deg, #fe9281 0%, #fc6046 100%),
    linear-gradient(#9b9b9b, #9b9b9b);
  background-blend-mode: normal, normal;
  border-radius: 6px;
  color: #fff;
}
.mianright-text {
  text-align: center;
  width: 50%;
  float: left;
}
.lnnerlayer {
  /* width: 80%;
  border-left: 1px solid #dcdfe6;
  float: right; */
}
.tablew {
  width: 50%;
  float: left;
  border-left: 1px solid #d0d0d0;
  box-sizing: border-box;
  padding-left: 20px;
}
.Plate1-right {
  width: 22%;
  height: 300px;
  float: left;
}
.con img {
  width: 100%;
  margin: 3% 0;
}
.Plate1-right >>> .el-input {
  margin-top: 20px;
}
.application {
  width: 270px;
  background: #fff;
  /* width: 290px; */
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.14);
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  margin: 0 auto;
  margin-left: 7%;
}
.application-form {
  width: 90%;
  margin: 0 auto;
}
.application-title {
  padding: 5px;
  font-size: 22px;
}
.application-form > .el-button--default {
  width: 100%;
  margin-top: 20px;
  background-image: linear-gradient(180deg, #fe9281 0%, #fc6046 100%),
    linear-gradient(#9b9b9b, #9b9b9b);
  background-blend-mode: normal, normal;
  border-radius: 6px;
  color: #fff;
}
.button-text {
  font-size: 14px;
  margin-top: 17px;
}
.bottom-img {
  width: 100%;
  height: 500px;
  display: flex;
  align-items: center;
  background-image: url(../assets/images/loan/zswy.jpg);
  background-size: contain;
}
.Mask {
  width: 100%;
  height: 400px;
}
.mask-title {
  font-size: 30px;
  text-align: center;
  color: #fff;
  font-weight: bold;
  margin-top: 20px;
}
.Mask ul {
  width: 1086px;
  overflow: hidden;
  margin: 0 auto;
  padding-inline-start: 0px;
  margin-top: 20px;
}
.Mask ul li {
  width: 200px;
  height: 230px;
  border: 1px solid #fff;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  float: left;
  list-style: none;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 20px;
}
.Mask ul li:not(:first-child) {
  margin-left: 20px;
}
.Mask ul li:hover {
  background-image: linear-gradient(180deg, #fe9281 0%, #fc6046 100%),
    linear-gradient(0deg, #000000 0%, #ffffff 100%);
  background-blend-mode: normal, normal;
  box-shadow: 0px 0px 16px 0px rgba(255, 255, 255, 0.26);
  border-radius: 20px;
}
.itemcent {
  width: 100%;
  text-align: center;
}
.itemcent > .iconfont {
  font-size: 60px;
}
.askanswer {
  width: 70%;
  height: 190px;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  padding: 10px;
  box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.14);
  display: flex;
  align-items: center;
}
.answer-title {
  font-size: 30px;
  color: #258ffc;
}
.ask {
  font-size: 18px;
  color: #258ffc;
  margin-top: 10px;
}
.askanswer-left .answer,
.askanswer-right .answer {
  font-size: 15px;
  line-height: 20px;
}
.askanswer-left {
  width: 45%;
  float: left;
  text-align: left;
}
.askanswer-right {
  width: 45%;
  float: left;
  text-align: left;
  margin-left: 10%;
}
.askanswer-wp {
  width: 80%;
  height: 300px;
  margin: 0 auto;
  margin-top: -98px;
}
.tablew >>> .el-table .cell {
  text-align: center;
}
.Amountdue {
  font-size: 45px;
  color: #c42d28;
  margin-top: 20px;
}
</style>
